import React from 'react';
import { Inline, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { TabContainer } from '../../TabContainer.tsx';

// Todo: Wrap with TabContiner with FG clean up for phantom-3633-playbook-routes-migration
export const PlaybookLogsLoadingView = () => (
	<Stack
		testId="playbooks-list-screen.ui.playbook-logs.edge-cases.loading"
		space="space.250"
		grow="fill"
		xcss={wrapperStyles}
	>
		<Inline spread="space-between">
			<Skeleton height={32} width={240} borderRadius={4} isShimmering />
			<Skeleton height={32} width={40} borderRadius={4} isShimmering />
		</Inline>
		<Stack space="space.100">
			<LoadingRow />
			<LoadingRow />
			<LoadingRow />
		</Stack>
	</Stack>
);

const LoadingRow = () => (
	<Inline space="space.100">
		<Skeleton height={32} width="22%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="16%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="16%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="16%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={4} isShimmering />
	</Inline>
);

// Todo: Clean up with FG phantom-3633-playbook-routes-migration
export const PlaybookWrappedLogsLoadingView = () => (
	<TabContainer>
		<PlaybookLogsLoadingView />
	</TabContainer>
);

const wrapperStyles = xcss({
	paddingTop: 'space.300',
});
